export const FOOTER_SECTIONS = [
  {
    header: 'FOOTER.HOME',
    links: [
      { label: 'FOOTER.LOGIN', url: 'https://app.echoza.ai/login', isExternal: true },
      { label: 'FOOTER.REQUEST_DEMO', fragment: 'home' }, // Scrolls to top/hero
      { label: 'FOOTER.WHY_ECHOZA', fragment: 'why-us' },
      { label: 'FOOTER.HOW_IT_WORKS', fragment: 'how-it-works' },
    ],
  },
  {
    header: 'FOOTER.SOLUTIONS',
    links: [
      { label: 'FOOTER.CONTENT_PUBLISHING', fragment: 'solutions' },
      { label: 'FOOTER.CAMPAIGN_MGMT', fragment: 'solutions' },
      { label: 'FOOTER.CONTENT_LIBRARY', fragment: 'solutions' },
      { label: 'FOOTER.UNIFIED_INBOX', fragment: 'solutions' },
    ],
  },
  {
    header: 'FOOTER.MORE',
    links: [
      { label: 'FOOTER.CONTACT_US', fragment: 'contact' },
      { label: 'FOOTER.FAQ', fragment: 'faq' },
      { label: 'FOOTER.PRIVACY_POLICY', url: '/privacy-and-policy', isExternal: false },
      { label: 'FOOTER.TERMS', url: '/terms-and-conditions', isExternal: false },
    ],
  },
];
